import React from "react";
import { Hero } from "./components/sections/Hero";
import { MiniTestimonials } from "./components/sections/MiniTestimonials";
import { Problem } from "./components/sections/Problem";
import { Tomos } from "./components/sections/Tomos";
import { Bonos } from "./components/sections/Bonos";
import { UrgencyBar } from "./components/sections/UrgencyBar";
import { Pricing } from "./components/sections/Pricing";
import { KitComparison } from "./components/sections/KitComparison";
import { Testimonials } from "./components/sections/Testimonials";
import { Guarantee } from "./components/sections/Guarantee";
import { Faq } from "./components/sections/Faq";
import { CostOfInaction } from "./components/sections/CostOfInaction";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <main className="w-full min-h-full bg-black text-white antialiased selection:bg-[#e10600] selection:text-white" data-id="element-0" data-mp="23vcikoy874a1">
      <Hero data-id="element-1" data-mp="3ikh98cxzsz0k" />
      <MiniTestimonials data-id="element-2" data-mp="3iiwdwl3utc1n" />
      <Problem data-id="element-3" data-mp="3ijfthv617oci" />
      <Tomos data-id="element-4" data-mp="3ihv0wb3a2fha" />
      <Bonos data-id="element-5" data-mp="3mljat0fdtn5p" />
      <UrgencyBar data-id="element-6" data-mp="3mlat8v8bdto6" />
      <Pricing data-id="element-7" data-mp="3mkrgru1fnxhj" />
      <KitComparison data-id="element-8" data-mp="3mk84otygs3bf" />
      <Testimonials data-id="element-9" data-mp="3mjg9hk8s47lo" />
      <Guarantee data-id="element-10" data-mp="3rc9d24sih9w6" />
      <Faq data-id="element-11" data-mp="3rbrayrj641gc" />
      <CostOfInaction data-id="element-12" data-mp="3rbzq6q2rjiup" />
      <FinalCta data-id="element-13" data-mp="3rcsyvwla8ifh" />
      <Footer data-id="element-14" data-mp="3recdzjv7cnfo" />
    </main>;
}